import { Paper } from '@mantine/core';

type Props = {
  children: React.ReactNode;
  bg?: string;
};

export function GradientBorderedCard({ children, bg }: Props) {
  return (
    <Paper
      px="xs"
      py="xxs"
      bg={bg}
      style={{
        position: 'relative',
        borderRadius: 12,
        overflow: 'hidden', // important so pseudo stays clipped
      }}
    >
      {children}

      <div
        style={{
          content: '""',
          position: 'absolute',
          inset: 0,
          padding: '1px',
          borderRadius: 12,
          background: `
              linear-gradient(184deg, rgba(255, 119, 28, 0) 47.53%, #FF771C 64.73%, rgba(255, 119, 28, 0) 81.93%),
              linear-gradient(100deg, #FEF0C7 36.14%, #FFF 59.3%, #FEF0C7 81.16%)
            `,
          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
          pointerEvents: 'none',
        }}
      />
    </Paper>
  );
}
